// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + (chunkId === 594 ? "about" : chunkId) + ".js";
};